import type { ICommonCompareBannerProps } from "app/pages/website-analysis/components/compare-banner/CommonCompareBanner";
import { CommonCompareBanner } from "app/pages/website-analysis/components/compare-banner/CommonCompareBanner";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { useSimilarSites } from "app/services/sitesService/hooks/useSimilarSites";
import { useWebsitesFavicons } from "app/services/sitesService/hooks/useWebsitesFavicons";

interface ICompareBannerProps extends Omit<ICommonCompareBannerProps, "domains" | "icons" | "onButtonClick"> {
    domain: string;
    trackClickCallback: () => void;
}

export const CompareBanner = ({ domain, trackClickCallback, ...props }: ICompareBannerProps) => {
    const { data: domainData } = useWebsitesFavicons([domain], undefined, {
        staleTime: Infinity,
    });
    const { data: similarSitesData } = useSimilarSites(domain, { limit: 4 }, {
        staleTime: 1000 * 60 * 60 * 24, // ONE_DAY
    });
    const similarSitesDomains = similarSitesData?.map((item) => item.Domain);

    if (!similarSitesDomains?.length) {
        return null;
    }

    const onClick = () => {
        trackClickCallback();
        void proNavigator.updateParams({
            key: `${domain},${similarSitesDomains.toString()}`,
        });
    };
    const icons = {
        [domain]: domainData?.[domain],
        ...similarSitesData.reduce<Record<string, string>>((acc, item) => {
            acc[item.Domain] = item.Favicon;
            return acc;
        }, {}),
    };

    return (
        <CommonCompareBanner
            domains={[domain, ...similarSitesDomains]}
            icons={icons}
            onButtonClick={onClick}
            {...props}
        />
    );
};
